import {MinimalStorableSummaryWithSchemaId} from 'constants/SampleConstants';
import {BioentitySummary} from 'graphql-client/declarative-translations/external/RESTTypes';
import {SchemaFieldSelectorsDict} from 'notebook/structured-tables/hooks/useSelectorsById';
import {StructuredTable, StructuredTableAdapter} from 'notebook/structured-tables/StructuredTableConstants';
import {FetchedContainerInfo} from 'notebook/structured-tables/util/fetchContainersFromPlateWellPositions';
import {EvaluatedCell} from 'notebook/tables/excess/Evaluator';
import {BaseTypedValueType} from 'notebook/tables/TableConstants';
import {CreateProcessButtonQuery} from 'processes/tables/create-process-button/__generated/CreateProcessButtonQuery';
import {ProcessTaskStructuredTable} from 'processes/tables/ProcessTaskStructuredTableAdapter';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export type ProcessTaskSchema =
  CreateProcessButtonQuery['processTaskSchemasSupportingPlatformFeature'][number];

type ColumnValues = Array<BioentitySummary> | Array<MinimalStorableSummaryWithSchemaId>;

export interface TaskColumnMappingInfoBase {
  columnName: string;
  columnIcon?: BenchlingIconName;
  hasValues: boolean;
}

export interface TaskColumnMappingInfoWithValues extends TaskColumnMappingInfoBase {
  columnValues: ColumnValues;
  hasValues: true;
}

export interface TaskColumnMappingInfoWithIds extends TaskColumnMappingInfoBase {
  columnType: BaseTypedValueType;
  columnIds: Array<string>;
  hasValues: false;
  shouldFetchPlateInfo: boolean;
}

export type TaskColumnMappingInfo = TaskColumnMappingInfoWithValues | TaskColumnMappingInfoWithIds;

export interface ColumnSummary {
  columnName: string;
  columnIcon?: BenchlingIconName;
  /** Index of this column on `taskTable.columns` (stable across picker order). */
  destinationColumnIndex: number;
}

export interface SelectTargetColumnModalSubmitResult {
  taskTable: ProcessTaskStructuredTable | null;
  shouldRunCreateModal: boolean;
}

export enum SelectTaskColumnMappingsModalCreationType {
  PROCESS = 'process',
  REQUEST_V2_SUBMISSION = 'request_v2_submission',
}

export interface SelectTargetColumnModalProps {
  sourceColumns: Array<TaskColumnMappingInfo>;
  taskSchema: ProcessTaskSchema;
  taskTable: ProcessTaskStructuredTable;
  selectorsById: SchemaFieldSelectorsDict;
  fetchedContainerInfo: FetchedContainerInfo | null;
  summariesById: Record<string, BioentitySummary | MinimalStorableSummaryWithSchemaId>;
  creationType: SelectTaskColumnMappingsModalCreationType;
  onRequestClose: () => void;
  onRequestSubmit: (result: SelectTargetColumnModalSubmitResult) => void;
}

export interface QueryingSelectTaskColumnMappingsModalProps {
  sourceColumns: Array<TaskColumnMappingInfo>;
  taskSchema: ProcessTaskSchema;
  taskTable: ProcessTaskStructuredTable;
  selectorsById: SchemaFieldSelectorsDict;
  onRequestClose: () => void;
  onRequestSubmit: (result: SelectTargetColumnModalSubmitResult) => void;
  creationType: SelectTaskColumnMappingsModalCreationType;
  structuredTableAdapter?: StructuredTableAdapter<unknown, unknown>;
  structuredTable?: StructuredTable<unknown, unknown>;
  computedTable?: Array<Array<EvaluatedCell>> | null;
}

export interface ColumnMappingModalSubmitControls {
  handleSubmit: () => void;
  submitButtonText: string;
  mapSubmitDisabled: boolean;
}

/** `null` means no selection (placeholder shown). */
export interface ColumnMappingRowState {
  sourceColumnIndex: number | null;
  destinationColumnIndex: number | null;
}
